import React, { useEffect, useRef, useState } from 'react'
import { hapticTick } from '../../../../../_utils/haptics'
import AutoGrow from './AutoGrow'
import { ArrowUp } from './icons'

// Starting points: some Bailey can do from the salon's own records ("post my
// free slots"), some only need finishing ("20% off ...")
const STARTERS = [
  { label: 'Free slots', text: 'Post my free slots for tomorrow' },
  { label: 'An offer', text: '20% off ' },
  { label: 'Latest review', text: 'Share our latest review' },
  { label: 'Someone new', text: 'Meet ' },
  { label: 'Our prices', text: 'Post our prices' },
  { label: 'Gift vouchers', text: 'Post our gift vouchers' },
]

// "Tell Bailey what to post": a sentence becomes a finished post, opened in
// the studio with what Bailey did and what's still needed
const BaileyAsk = ({ onAsk, busy, note, starters = true }) => {
  const [text, setText] = useState('')
  const [slow, setSlow] = useState(false)
  const input = useRef(null)
  // Bailey writing a whole post takes a moment: say so
  useEffect(() => {
    setSlow(false)
    if (!busy) return undefined
    const t = setTimeout(() => setSlow(true), 8000)
    return () => clearTimeout(t)
  }, [busy])
  const send = async () => {
    const t = text.trim()
    if (!t || busy) return
    hapticTick()
    const made = await onAsk(t)
    if (made) setText('')
  }
  const begin = (s) => {
    hapticTick()
    setText(s.text)
    setTimeout(() => {
      const el = input.current
      if (!el) return
      el.focus()
      try { el.setSelectionRange(el.value.length, el.value.length) } catch (e) { /* older browsers */ }
    }, 0)
  }
  return (
    <div className="sx-askhome">
      <form className="sx-ask" onSubmit={(e) => { e.preventDefault(); send() }}>
        <AutoGrow
          ref={input}
          singleLine
          className="sx-ask-input"
          value={text}
          onChange={setText}
          placeholder="Tell Bailey what to post"
          aria-label="Tell Bailey what to post"
          enterkeyhint="send"
          onKeyDown={(e) => { if (e.key === 'Enter') send() }}
        />
        <button type="submit" className={`sx-ask-go${busy ? ' is-busy' : ''}`} disabled={busy || !text.trim()} aria-label="Make the post">
          {busy ? <span className="sx-spin" aria-hidden /> : <ArrowUp size={18} />}
        </button>
      </form>
      {busy && <p className="sx-askhome-note sx-thinking-line" role="status">{slow ? 'Still writing, nearly there' : 'Bailey’s writing your post'}<span className="sx-dots" aria-hidden><i /><i /><i /></span></p>}
      {!busy && note && <p className="sx-askhome-note" role="status">{note}</p>}
      {starters && (
        <div className="sx-ask-chips" aria-label="Start from">
          {STARTERS.map(s => <button key={s.label} type="button" className="sx-chip" onClick={() => begin(s)}>{s.label}</button>)}
        </div>
      )}
    </div>
  )
}

export default BaileyAsk
